import { Injectable } from '@angular/core';
import {Record, ServiceCRUD} from './service-crud.service';
import {Observable} from 'rxjs';
import {Rights} from './auth.service';
import { map } from 'rxjs/operators';

export interface GroupDto extends Record {
  name: string;
}

interface UserRawDto extends Record {
  username: string;
  first_name: string;
  last_name: string;
  middle_name?: string;
  group?: string;
  avatar?: string;
  password?: string;
  employee?: string;
}

export interface UserDto extends Record {
  username: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  group?: string;
  avatar?: string;
  password?: string;
  passwordConfirmation?: string;
  employee?: string;
}

interface UserRawReadableDto extends Record {
  username: string;
  first_name: string;
  last_name: string;
  middle_name?: string;
  group?: GroupDto;
  avatar?: string;
  employee?: string;
}

export interface UserReadableDto extends Record {
  username: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  group?: GroupDto;
  avatar?: string;
  employee?: string;
}

export class UserInstanceDto implements UserDto {
  public id = '';
  public username = '';
  public firstName = '';
  public lastName = '';
  public middleName = '';
  public group = '';
}

@Injectable({
  providedIn: 'root'
})
export class UsersService extends ServiceCRUD<UserDto, UserReadableDto, UserRawDto, UserRawReadableDto> {
  public get object(): keyof Rights {
    return 'user';
  }

  public readableToManageable(record: UserReadableDto): UserDto {
    return {
      ...record,
      group: record.group && record.group.id
    };
  }

  public getGroups(): Observable<GroupDto[]> {
    return this.makeGetCall('get-groups');
  }

  public getCurrentUser(): Observable<UserReadableDto> {
    return this.makeGetCall('get-current-user').pipe(map<UserRawReadableDto, UserReadableDto>(this.convertRawToProcessed));
  }

  protected convertRawToProcessed(record: UserRawReadableDto): UserReadableDto {
    return {
      id: record.id,
      username: record.username,
      firstName: record.first_name,
      lastName: record.last_name,
      middleName: record.middle_name,
      group: record.group,
      avatar: record.avatar,
      employee: record.employee
    };
  }

  protected convertProcessedToRaw(record: UserDto): UserRawDto {
    return {
      id: record.id,
      username: record.username,
      first_name: record.firstName,
      last_name: record.lastName,
      middle_name: record.middleName,
      group: record.group,
      avatar: record.avatar,
      password: record.password,
      employee: record.employee
    };
  }
}
